module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapname"
  }, [_c('span', {
    staticClass: "chaps"
  }, [_vm._v("L")]), _vm._v("IST OF ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("Adm. ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Admiralty or Admiralty Records in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("BCA ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("British Columbia Archives, Victoria, BC")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("Bod. L. ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Bodleian Library, Oxford")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("BL ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("British Library Manuscripts (formerly in the British Museum), London")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("BT ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Board of Trade Records in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("Cab. ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Cabinet Papers in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("CDC ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Colonial Defence Committee")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("CMS ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Church Missionary Society or Church Missionary Society Records, University of Birmingham")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("CO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Colonial Office or Colonial Office Records in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("FO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Foreign Office or Foreign Office Records in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HBC ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Hudson’s Bay Company")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HBCA ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Hudson’s Bay Company Archives, Winnipeg, Manitoba")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HM ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Her/His Majesty")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HMCS ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Her/His Majesty’s Canadian Ship")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HMS ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Her/His Majesty’s Ship")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HMSO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("His/Her Majesty’s Stationery Office")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("HO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Hydrographer’s Office, Taunton, Somerset")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("KCB/CB ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Knight Commander or Companion of the Order of the Bath")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("LAC ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Library and Archives Canada, Ottawa, Ontario")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("MMBC ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Maritime Museum of British Columbia, Victoria, BC")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("NL ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Naval Library, Ministry of Defence, Royal Naval Museum, Portsmouth, England")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("NMM ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("National Maritime Museum, Greenwich (now part of Royal Museums Greenwich)")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("PRO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Public Records Office")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("RCS ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Royal Commonwealth Society Collections, Cambridge University Library, Cambridge")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("RE ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Royal Engineers")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("RM ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Royal Marines")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("RMLI ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Royal Marine Light Infantry")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("RN ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Royal Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("TNA ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The National Archives, Kew, Surrey")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("USN ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("United States Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("USS ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("United States Ship")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("WO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("War Office or War Office Records in TNA")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("WRO ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Warwickshire Record Office, Warwick")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    staticClass: "ts31"
  }, [_vm._v("12n26 ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("In a bibliographic note, refers to, in this example, note 26 on page 12")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e0e3c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List_of_abbreviations.vue
// module id = 72
// module chunks = 0